import type { MedicationStatementModel } from '@ctw/shared/api/fhir/models/medication-statement';
import type { OverviewCardDataProps } from '@ctw/shared/content/overview/resource-overview-card';
import { ResourceOverviewCard } from '@ctw/shared/content/overview/resource-overview-card';
import { useCTW } from '@ctw/shared/context/ctw-context';
import { faPills } from '@fortawesome/pro-solid-svg-icons';
import { RenderSyncedWithRecordIcon, ResourceTitleColumn } from '../resource/resource-title-column';

const TITLE = 'Medications';

export type PatientMedicationOverviewCardProps = OverviewCardDataProps<MedicationStatementModel>;

/**
 * Presentational medications overview card. Renders the pre-filtered/sorted
 * list it is handed; data fetching lives in `usePatientMedicationsOverviewData`.
 */
export const PatientMedicationOverviewCard = ({
  data,
  isLoading,
  emptyState,
  footerCTA,
  onRowClick,
}: PatientMedicationOverviewCardProps) => {
  const { requestContext } = useCTW();

  return (
    <ResourceOverviewCard
      onRowClick={onRowClick}
      data={data}
      emptyState={emptyState}
      footerCTA={footerCTA}
      title={TITLE}
      helpText="Medications with prescriptions or fills within the last 6 months"
      loading={isLoading}
      headerIcon={faPills}
      testId="medications-overview"
      renderResource={(record: MedicationStatementModel) => (
        <ResourceTitleColumn
          title={record.display}
          renderIcon={RenderSyncedWithRecordIcon(record.ownedByBuilder(requestContext.builderId))}
        />
      )}
    />
  );
};
